export class UpdateDoctorLeadRequest {
    clinicName: string;
    firstName: string;
    lastName: string;
    emailId: string;
    mobileNumber: string;
    keySkills: string;
    qualification: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    pincode: string;
}
